import { createContext, useContext, useState, ReactNode } from 'react';

interface RecipientsContextType {
  guestIdForEmailEdit: string | null;
  setGuestIdForEmailEdit: (id: string | null) => void;
}

const RecipientsContext = createContext<RecipientsContextType | undefined>(undefined);

interface RecipientsProviderProps {
  children: ReactNode;
}

export const RecipientsProvider = ({ children }: RecipientsProviderProps) => {
  const [guestIdForEmailEdit, setGuestIdForEmailEdit] = useState<string | null>(null);

  return (
    <RecipientsContext.Provider value={{ guestIdForEmailEdit, setGuestIdForEmailEdit }}>
      {children}
    </RecipientsContext.Provider>
  );
};

export const useRecipientsContext = () => {
  const context = useContext(RecipientsContext);
  if (context === undefined) {
    throw new Error('useRecipientsContext must be used within a RecipientsProvider');
  }
  return context;
};
